<div
  id="menu"
  class="menu d-flex flex-column"
  [ngClass]="{ 'menu-sticky': sticky, expandable: isMenuExpanded }"
  role="navigation"
  aria-label="Menu de navegação">
  <div class="content z-0" role="menu">
    <ui-fh-menu-item *ngFor="let item of items | fhMenuFeatures : validateFeatures" [item]="item"></ui-fh-menu-item>
  </div>
</div>
